/* eslint-disable id-match */
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { BOOKING_CALENDAR_PASSENGERS } from '../../../../brands/default/content/components/deal';
import { getPassengerOptions } from '../../../../helpers/booking';
import CustomNativeSelect from '../../../_generic/custom-native-select/CustomNativeSelect';

const BookingCalendarPassengers = ({ initialQuantity, onQuantityChange }) => {
  const [selectedValue, setSelectedValue] = useState(initialQuantity);
  const values = getPassengerOptions();
  const { cyfBookingStepOne } = BOOKING_CALENDAR_PASSENGERS;
  const onChange = (event) => {
    setSelectedValue(event.target.value);
    onQuantityChange(event.target.value);
  };

  return (
    <>
      <CustomNativeSelect
        ariaLabel={cyfBookingStepOne}
        /* eslint-disable-next-line react/forbid-component-props */
        className="full-width margin"
        id="num-passengers"
        onChange={onChange}
        value={selectedValue}
      >
        {values.map((item) => {
          return (
            <option key={item.quantity} value={item.quantity}>
              {item.label}
            </option>
          );
        })}
      </CustomNativeSelect>
    </>
  );
};

BookingCalendarPassengers.propTypes = {
  initialQuantity: PropTypes.number.isRequired,
  onQuantityChange: PropTypes.func.isRequired,
};

export default BookingCalendarPassengers;
